var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-content"},[_c('b-spinner',{staticClass:"mr-2",attrs:{"label":"Spinning","small":""}}),_vm._v(" "+_vm._s(_vm.$t('common.loading'))+"... ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }